import { prefixTypes, createActionWithPath } from 'Modules/core/redux';


const types = prefixTypes('certificates', {
    SET_LIST: 'SET_LIST',
    SET_ERROR: 'SET_ERROR',
    UPDATE_LIST: 'UPDATE_LIST',
    SET_CERTIFICATE: 'SET_CERTIFICATE',
});

export { types as certificatesActionTypes };

export const certificatesActions = {
    setList: createActionWithPath(types.SET_LIST),
    setError: createActionWithPath(types.SET_ERROR),
    updateList: createActionWithPath(types.UPDATE_LIST),
    setCertificate: createActionWithPath(types.SET_CERTIFICATE),
};
